/**
 * 日报实体
 */
import User from "@/models/User";

export default class DailyReport {

    id
    creator
    createDate
    updater
    updateDate
    title
    receiver
    read
    count
    unreadCount
    suggestCount
    unusedCount

    constructor(props) {
        const pp = props ||  {}
        this.id = pp.id || ''
        this.creator = new User(pp.creator)
        this.updater = new User(pp.updater)
        this.createDate = pp.createDate
        this.updateDate = pp.updateDate
        this.title = pp.title || ''
        this.receiver = new User(pp.receiver)
        this.read = !!pp.read
        this.count = pp.count || 0
        this.unreadCount = pp.unreadCount || 0
        this.suggestCount = pp.suggestCount || 0
        this.unusedCount = pp.unusedCount || 0
    }
}
